import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import BaseSearchFilter from '@libs/@core/components/search-filter/BaseSearchFilter';
import useCashFlowTemplateController from '@modules/cashflow/cf-template/controllers/cf-template.controller';
import useGetCashflowTemplateList from '@modules/cashflow/cf-template/hooks/queries/useGetCashflowTemplateList';
import BaseTable from '@libs/@core/components/table/BaseTable';
import { customStyle, headerStyle } from '@libs/models/table.model';
import useGetFilterList from '@modules/cashflow/cf-template/hooks/useGetFilterList';
import useCustomTranslation from '@libs/hooks/useCustomTranslation';
import useGetColumnTable from '@modules/cashflow/cf-template/hooks/useGetColumnTable';
var defaultValues = {
    templateName: '',
    date: [],
    submit_date: []
};
var CashFlowTemplateTemplate = function () {
    var _a = useCashFlowTemplateController(), listBtns = _a.listBtns, actions = _a.actions, handleSearch = _a.handleSearch, handleChangePagination = _a.handleChangePagination;
    var _b = useGetCashflowTemplateList(), cfTemplateList = _b.data, isFetching = _b.isFetching;
    var listFilters = useGetFilterList().listFilters;
    var t = useCustomTranslation();
    var columns = useGetColumnTable();
    return (_jsxs("div", { className: 'p-8', children: [_jsx(BaseSearchFilter, { title: t('L000080'), defaultValues: defaultValues, listBtns: listBtns, listFilters: listFilters, handleSearch: handleSearch }), _jsx("div", { className: 'flex justify-between py-3', children: _jsx("h3", { className: 'text-lg', children: t('L000190') }) }), _jsx(BaseTable, { data: (cfTemplateList === null || cfTemplateList === void 0 ? void 0 : cfTemplateList.data) || [], isLoading: isFetching, columns: columns, checkedIndex: 'id', actions: actions, pagination: {
                    page: cfTemplateList === null || cfTemplateList === void 0 ? void 0 : cfTemplateList.pagination.page,
                    limit: cfTemplateList === null || cfTemplateList === void 0 ? void 0 : cfTemplateList.pagination.pageSize,
                    totalPage: cfTemplateList === null || cfTemplateList === void 0 ? void 0 : cfTemplateList.pagination.totalPages,
                    handleChangePagination: handleChangePagination
                }, headerStyle: headerStyle, customStyle: customStyle })] }));
};
export default CashFlowTemplateTemplate;
